/**
 * Decode a base64 payload (raw, no data-URI prefix) into a Blob so it can be saved
 * with file-saver. Throws on malformed base64 — callers should catch and toast.
 */
export const base64ToBlob = (base64: string, type = "application/pdf") => {
  const byteString = atob(base64);
  const bytes = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    bytes[i] = byteString.charCodeAt(i);
  }
  return new Blob([bytes], { type });
};
